import React, { useState } from "react";
import Axios from "axios";
import styled from "styled-components";

const Review = () => {
  const Button = styled.button`
    background-color: ${window.lrmSettings["primary"]};
    border: none;
    cursor: pointer;
    padding: 5px 10px;
    transition: all ease-in-out 0.2s;
    color: #fff;
    &:hover {
      background: #d3d3d3;
      color: #000;
    }
  `;
  const [formLoading, setFormLoading] = useState(false);
  const [serverResponse, setServerResponse] = useState();
  const [formResponseLoaded, setFormResponseLoaded] = useState(false);
  const [newReview, setNewReview] = useState(false);
  const [writeReviewForm, setWriteReviewForm] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const handleReviewForm = (e) => {
    e.preventDefault();
    setFormLoading(true);
    Axios({
      method: "post",
      url: "/wp-content/plugins/lrm-reviews/includes/review-post.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        stars: e.target.stars.value,
        comments: e.target.comments.value,
        name: e.target.name.value,
        email: e.target.email.value,
        city: e.target.city.value,
      },
    }).then(function (response) {
      setFormResponseLoaded(true);
      setFormLoading(false);
      setServerResponse(response.data);
    });
  };
  const handleBackButton = () => {
    setWriteReviewForm(false);
    setNewReview(true);
  };
  const NewReview = () => {
    setNewReview(true);
  };
  const WriteReview = () => {
    setWriteReviewForm(true);
  };
  const handleReset = () => {
    setNewReview(false);
  };
  if (formLoading) {
    return <p>Submitting</p>;
  }
  if (formResponseLoaded) {
    return <p>{serverResponse}</p>;
  }
  const handleTextareaChange = (e) => {
    setCharCount(e.target.value.length);
  };

  if (writeReviewForm) {
    return (
      <div class="lrm-reviews-form">
        <button onClick={handleBackButton} className="lrm-reviews-back">
          <p>
            <i class="fas fa-arrow-left"></i> back
          </p>
        </button>
        <form onSubmit={handleReviewForm}>
          <label>Rating: </label>
          <br />
          <select name="stars" className="lrm-reviews-form-control" required>
            <option value="5">5 Stars</option>
            <option value="4">4 Stars</option>
            <option value="3">3 Stars</option>
            <option value="2">2 Stars</option>
            <option value="1">1 Star</option>
          </select>
          <br />
          <label>Full Name:</label>
          <input
            type="text"
            className="lrm-reviews-form-control"
            name="name"
            required
          />
          <br />
          <label>Email:</label>
          <input
            type="text"
            className="lrm-reviews-form-control"
            name="email"
            required
          />
          <br />
          <label>City:</label>
          <input
            type="text"
            className="lrm-reviews-form-control"
            name="city"
            required
          />
          <br />
          <label>Describe Your Experience:</label>
          <br />
          <textarea
            name="comments"
            className="lrm-reviews-form-control"
            onChange={handleTextareaChange}
            required
          ></textarea>
          <div class="lrm-reviews-submit-container">
            <p className="lrm-reviews-subtext">
              <span className={charCount > 50 && "lrm-reviews-hide-counter"}>
                {charCount}/50 | We recommend reviews be at least 50 characters
                <br />
              </span>
              Your review may be shared publicly on the web. Privacy Policy -
              Terms of Service
            </p>
            <Button
              className="lrm-reviews-btn lrm-reviews-submit"
              type="submit"
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
  if (newReview) {
    return (
      <div className="lrm-reviews-which-review">
        <button onClick={handleReset} className="lrm-reviews-back">
          <p>
            <i class="fas fa-arrow-left"></i> back
          </p>
        </button>
        <p id="newReviewHeader">
          Which service would you like to leave your review on?
        </p>
        <div className="lrm-reviews-review-choices">
          {/* <a
            href={window.lrmSettings["facebook"]}
            className="lrm-reviews-review-icon"
            id="facebook"
          >
            <i className="fab fa-facebook-square"></i>
          </a> */}
          <a
            href={window.lrmSettings["google"]}
            className="lrm-reviews-btn lrm-reviews-website-review"
            id="google"
            style={{ backgroundColor: window.lrmSettings["primary"] }}
          >
            Google
          </a>
          <Button
            className="lrm-reviews-btn lrm-reviews-website-review"
            onClick={WriteReview}
          >
            Website
          </Button>
        </div>
      </div>
    );
  }

  if (!newReview) {
    return (
      <Button
        className="lrm-reviews-btn lrm-reviews-write-review"
        onClick={NewReview}
      >
        Write A Review
      </Button>
    );
  }
};

export default Review;
